import { Paper, TextField } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import NoResultsText from '../common/NoResultsText';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textFieldInput: {
      paddingTop: 12,
      paddingBottom: 12
    },
    toolbar: {
      marginBottom: 8
    },
  })
);

interface Props {
  items: any[]
  noResultsText: string
  searchPlaceholder: string
}

function GroupDetailsPageTable({ items, noResultsText, searchPlaceholder }: Props) {
  const classes = useStyles({});
  const [search, setSearch] = useState('');

  const filteredItems = search ? items.filter(item => item.includes(search)) : items;

  return <div>
    {(search || filteredItems.length > 0) && <div className={classes.toolbar}>
      <TextField
        id="search"
        value={search}
        autoComplete="off"
        fullWidth
        margin="none"
        variant="outlined"
        placeholder={searchPlaceholder}
        inputProps={{ 'aria-label': 'bare', className: classes.textFieldInput }}
        onChange={event => setSearch(event.target.value)}
      />
    </div>}
    <Paper>
      <Table>
        <TableBody>
          {filteredItems.map(row => (
            <TableRow key={row}>
              <TableCell>
                {row}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!search && filteredItems.length === 0 && <NoResultsText>
        {noResultsText}
      </NoResultsText>}
    </Paper>
    {search && filteredItems.length === 0 && <NoResultsText>
      No items matching search <strong>{search}</strong>
    </NoResultsText>}
  </div>
};

export default GroupDetailsPageTable;
